// assets/sold-info.js
document.addEventListener('DOMContentLoaded', function () {
  function mulberry32(seed) {
    return function() {
      var t = seed += 0x6D2B79F5;
      t = Math.imul(t ^ (t >>> 15), t | 1);
      t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
      return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    }
  }

  // Configure:
  // mode: "per_load" or "deterministic"
  // deterministicRotateHours: number (if deterministic, rotate after this many hours; set 0 to never rotate)
  var config = {
    mode: "per_load",            // or "deterministic"
    minSold: 3,                  // minimum sold number
    maxSold: 12,                 // maximum sold number
    minHours: 1,                 // minimum hours
    maxHours: 12,                // maximum hours
    deterministicRotateHours: 6  // only used when mode === "deterministic"
  };

  var nodes = document.querySelectorAll('.sold-info[data-product-id]');
  if (!nodes.length) return;

  nodes.forEach(function(node) {
    var productId = parseInt(node.getAttribute('data-product-id'), 10) || 0;

    // derive a seed
    var baseSeed = productId || Math.floor(Math.random() * 1e9);

    if (config.mode === "deterministic") {
      var rotate = Math.max(0, parseInt(config.deterministicRotateHours, 10) || 0);
      if (rotate > 0) {
        var hoursSinceEpoch = Math.floor(Date.now() / (1000 * 60 * 60));
        // rotate per block of `rotate` hours so values update periodically
        var block = Math.floor(hoursSinceEpoch / rotate);
        baseSeed = baseSeed + block;
      }
      // else keep baseSeed = productId => never rotates
    } else {
      // per_load => mix in time so it differs each load
      baseSeed = baseSeed ^ Math.floor(Date.now() / 1000);
    }

    var rnd = mulberry32(baseSeed);

    // generate numbers
    var soldCount = Math.floor(rnd() * (config.maxSold - config.minSold + 1)) + config.minSold;
    var soldHours = Math.floor(rnd() * (config.maxHours - config.minHours + 1)) + config.minHours;

    // optional: small humanization rules
    if (soldCount <= 1) soldCount = 1;
    if (soldHours <= 0) soldHours = 1;

    // render
    var elCount = node.querySelector('.sold-info__count');
    var elHours = node.querySelector('.sold-info__hours');

    if (elCount) elCount.textContent = soldCount;
    if (elHours) elHours.textContent = soldHours;

    // add classes for styling or animation
    node.classList.add('sold-info--visible');
  });
});
